module.exports = __webpack_public_path__ + "assets/img/ppt_icon.a870acc9.svg";